(() => {
  if (window.roastivaTesterMultiselectLoaded) return;
  window.roastivaTesterMultiselectLoaded = true;

  const pickerSelector = "variant-picker[data-roastiva-tester-multi='true']";
  const cardSelector = '.roastiva-tester-flavor-card';

  const getForms = (picker) => {
    const scope = picker.closest('.shopify-section, dialog') || document;
    const productId = picker.dataset.productId;
    return Array.from(scope.querySelectorAll("product-form-component[data-roastiva-tester-multi='true']")).filter(
      (form) => !productId || form.dataset.productId === productId
    );
  };

  const sync = (picker) => {
    const total = Array.from(picker.querySelectorAll(`${cardSelector}[data-roastiva-quantity]`)).reduce(
      (sum, card) => sum + (Number(card.dataset.roastivaQuantity) || 0),
      0
    );

    for (const form of getForms(picker)) {
      for (const button of form.querySelectorAll('[ref="addToCartButton"]')) {
        button.disabled = total === 0;
        button.setAttribute('aria-disabled', total === 0 ? 'true' : 'false');
      }
    }
  };

  const updateCard = (card, nextQuantity) => {
    const quantity = Math.max(0, nextQuantity);
    const count = card.querySelector('.roastiva-tester-flavor-card__count');
    const minus = card.querySelector('.roastiva-tester-flavor-card__minus');

    if (quantity > 0) {
      card.dataset.roastivaQuantity = String(quantity);
      card.classList.add('roastiva-tester-flavor-card--has-quantity');
      if (count) count.textContent = `+${quantity}`;
      if (minus) minus.tabIndex = 0;
    } else {
      delete card.dataset.roastivaQuantity;
      card.classList.remove('roastiva-tester-flavor-card--has-quantity');
      if (count) count.textContent = '+0';
      if (minus) minus.tabIndex = -1;
    }

    const picker = card.closest(pickerSelector);
    if (picker) sync(picker);
  };

  const initialize = (root = document) => {
    const pickers = root.matches?.(pickerSelector) ? [root] : root.querySelectorAll?.(pickerSelector) || [];
    for (const picker of pickers) {
      if (picker.dataset.roastivaMultiReady === 'true') continue;
      picker.dataset.roastivaMultiReady = 'true';
      for (const input of picker.querySelectorAll(`${cardSelector} input`)) {
        input.checked = false;
        input.dataset.currentChecked = 'false';
        input.dataset.previousChecked = 'false';
      }
      sync(picker);
    }
  };

  document.addEventListener(
    'click',
    (event) => {
      const card = event.target.closest?.(cardSelector);
      const picker = card?.closest?.(pickerSelector);
      if (!card || !picker) return;

      const input = card.querySelector('input');
      if (!input || input.dataset.optionAvailable !== 'true' || input.getAttribute('aria-disabled') === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const current = Number(card.dataset.roastivaQuantity) || 0;
      const isMinus = Boolean(event.target.closest?.('.roastiva-tester-flavor-card__minus'));
      updateCard(card, isMinus ? current - 1 : current + 1);
    },
    true
  );

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const minus = event.target.closest?.('.roastiva-tester-flavor-card__minus');
    if (!minus) return;
    event.preventDefault();
    minus.click();
  });

  initialize();
  new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element) initialize(node);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
